var map = {
	"./css/global.css": 88,
	"./img/casamuyowall.jpg": 566,
	"./img/food-BOGAVANTE.jpg": 642,
	"./img/food-PAELLA.jpg": 0,
	"./img/food5.jpg": 255,
	"./img/gallery/1.jpg": 296,
	"./img/gallery/2.jpg": 967,
	"./img/gallery/3.jpg": 34,
	"./img/gallery/4.jpg": 521,
	"./img/gallery/5.jpg": 732,
	"./img/gallery/6.jpg": 179,
	"./img/guru/1.png": 51,
	"./img/guru/2.png": 560,
	"./img/guru/3.png": 177,
	"./img/hall.jpg": 565,
	"./img/history_01.jpeg": 363,
	"./img/history_02.jpeg": 718,
	"./img/history_03.jpeg": 405,
	"./img/logoBlack.jpeg": 921,
	"./img/logoRed.jpeg": 837,
	"./img/logoWhite.jpeg": 623,
	"./img/menu/menu-navidad.jpeg": 556,
	"./img/open-door.jpeg": 872,
	"./img/paella-rice.jpeg": 6,
	"./img/paella.jpeg": 128,
	"./img/social-media-logos/facebook_64.png": 889,
	"./img/social-media-logos/instagram_64.png": 387,
	"./img/social-media-logos/whatsapp_64.png": 99,
	"./img/social-media-logos/youtube_64.png": 834,
	"./img/tasteatlas.jpg": 190,
	"./img/team_01.jpg": 433,
	"./img/team_02.jpg": 294,
	"./pdf/carta-vino.pdf": 674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;